module.exports = __webpack_public_path__ + "img/service_image8.e5569db7.jpg";